import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IOrganisationIndex } from "../../organisations/model/OrganisationIndex";
import OrganisationIndexMapper from "../../organisations/service/OrganisationIndexMapper";
import OrganisationIndexParamMapper from "../../organisations/service/OrganisationIndexParamMapper";
import Constants from "../common/Constants";

export default class GetLegalViewIndexesInteractor {
  private resource: GetAllResourceEntriesInteractor<IOrganisationIndex>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(id: number) {
    return this.resource.execute(
      `/${Constants.endpointBasePath}/${id}/indexes`,
      OrganisationIndexMapper,
      OrganisationIndexParamMapper
    );
  }
}
